<template>
    <div>
        <v-card>
            <v-card-title>Q{{ qno }}. {{ currentQuestion.ques }}</v-card-title>
            <!-- <v-card-subtitle>{{ currentQuestion.ques }}</v-card-subtitle> -->
            <v-card-actions v-if="currentQuestion.quesimage != undefined" class="justify-center">
                <img v-bind:src="currentQuestion.quesimage" class="img-fluid" />
            </v-card-actions>
            <v-card-text>
                <!-- <v-radio-group>
                    <div v-for="(answer, index) in shuffledAnswers" :key="index" @click.prevent="selectAnswer(index)">
                        <v-radio v-model="radio" :label="answer" :value="index" @input="clicked"></v-radio>
                    </div>
                </v-radio-group> -->
                <v-list flat shaped>
                    <v-list-item-group>
                        <v-list-item v-for="(answer, index) in shuffledAnswers" :key="index" @click.prevent="selectAnswer(index)" :class="answerClass(index)" :disabled="answered" @click="submitAnswer" style="color: #000 !important;">
                            {{ answer }}
                        </v-list-item>
                    </v-list-item-group>
                </v-list>
            </v-card-text>
            <v-card-actions class="justify-center mb-5">
                <!-- <v-btn color="primary" @click="submitAnswer" :disabled="selectedIndex === null || answered"> Submit </v-btn> -->
                <v-btn color="primary text-white outnone" @click="next"> Next </v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>



<script>

import _ from 'lodash'

export default {
    props: {
        currentQuestion: Object,
        next: Function,
        increment: Function,
        qno: Number
    },
    data () {
        return {
            selectedIndex: null,
            correctIndex: null,
            shuffledAnswers: [],
            answered: false,
            // radio: null
        }
    },
    watch: {
        currentQuestion: {
            immediate: true,
            handler () {
                this.selectedIndex = null
                this.answered = false
                this.shuffleAnswers()
            }
        }
    },
    methods: {
        // clicked () {
        //     this.$nextTick(() => {
        //         this.radio = null
        //     })
        // },
        selectAnswer (index) {
            this.selectedIndex = index
        },
        submitAnswer () {
            let isCorrect = false
            if (this.selectedIndex === this.correctIndex) {
                isCorrect = true
            }
            this.answered = true
            this.increment(isCorrect)
        },
        shuffleAnswers() {
            let answers = [this.currentQuestion.op1, this.currentQuestion.op2, this.currentQuestion.op3, this.currentQuestion.ans]
            this.shuffledAnswers = _.shuffle(answers)
            this.correctIndex = this.shuffledAnswers.indexOf(this.currentQuestion.ans)
        },
        answerClass (index) {
            let answerClass = ''

            if (!this.answered && this.selectedIndex === index) {
                answerClass = 'selected'
            }
            else if (this.answered && this.correctIndex === index) {
                answerClass = 'correct'
            }
            else if (this.answered &&
                this.selectedIndex === index &&
                this.correctIndex !== index
            ) {
                answerClass = 'incorrect'
            }

            return answerClass
        }
    }
}

</script>



<style lang="scss" scoped>

.list-group {
  margin-bottom: 15px;
}

.list-group-item:hover {
  background: #EEE;
  cursor: pointer;
}

.btn {
  margin: 0 5px;
}

.selected {
  background-color: lightblue;
}

.correct {
  background-color: #99FFCC;
}

.incorrect {
  background-color: #EE7C7C;
}

.outnone {
    outline: none;
}

</style>